import React from "react";
import { useNavigate } from 'react-router-dom'; 
import { useEffect, useState ,useRef} from 'react';

import locationIcon from "../../assets/locationn.png";
import fulltimeIcon from "../../assets/fulltime-icon.png";
import experienceIcon from "../../assets/experience-icon.png";

import uploadIcon from "../../assets/upload-icon.svg";

const JobDetails = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
            // const [isServicesOpen, setIsServicesOpen] = useState(false);
            // const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
            // const [isCompanyOpen, setIsCompanyOpen] = useState(false);
          
            const toggleMobileMenu = () => {
              setIsMobileMenuOpen(!isMobileMenuOpen);
            };
          
            // const toggleServicesDropdown = () => {
            //   setIsServicesOpen(!isServicesOpen);
            // };
          
            // const toggleIndustriesDropdown = () => {
            //   setIsIndustriesOpen(!isIndustriesOpen);
            // };
          
            // const toggleCompanyDropdown = () => {
            //   setIsCompanyOpen(!isCompanyOpen);
            // };
      
        const [openDropdown, setOpenDropdown] = useState(null);
        const navRef = useRef(null);
      
        // Close dropdown on outside click
        useEffect(() => {
          const handleClickOutside = (event) => {
            if (navRef.current && !navRef.current.contains(event.target)) {
              setOpenDropdown(null);
            }
          };
          document.addEventListener('mousedown', handleClickOutside);
          return () => document.removeEventListener('mousedown', handleClickOutside);
        }, []);
      
        const toggleDropdown = (dropdown) => {
          setOpenDropdown(openDropdown === dropdown ? null : dropdown);
        };
        
        const navigate = useNavigate();
       
        const handleClick = () => {
          navigate("/Contact#contact-section");
        };
          const [isOpen, setIsOpen] = useState(false);
                
                  // const toggleDropdown = () => {
                  //   setIsOpen((prev) => !prev);
                  // };
            
            
                  const [isServicesOpen, setIsServicesOpen] = useState(false);
              const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
              const [isCompanyOpen, setIsCompanyOpen] = useState(false);
            
              // Toggle functions for dropdowns
              const toggleServicesDropdown = () => {
                setIsServicesOpen(!isServicesOpen);
                setIsIndustriesOpen(false);
                setIsCompanyOpen(false); // Close other dropdowns
              };
            
              const toggleIndustriesDropdown = () => {
                setIsIndustriesOpen(!isIndustriesOpen);
                setIsServicesOpen(false);
                setIsCompanyOpen(false); // Close other dropdowns
              };
            
              const toggleCompanyDropdown = () => {
                setIsCompanyOpen(!isCompanyOpen);
                setIsServicesOpen(false);
                setIsIndustriesOpen(false); // Close other dropdowns
              };
                  const [word, setWord] = useState('Today');
            
              useEffect(() => {
                const interval = setInterval(() => {
                  setWord((prev) => (prev === 'Today' ? 'Tomorrow' : 'Today'));
                }, 2000);
                return () => clearInterval(interval);
              }, []);
 

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };
    const applyFormRef = useRef(null);

   const [formData, setFormData] = useState({
    name: "",
    mobile_number: "",
    email: "",
    cover_letter: "",
    resume: null,
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handlleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "resume") {
      setFormData({ ...formData, resume: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      let base64Resume = "";
      if (formData.resume) {
        base64Resume = await fileToBase64(formData.resume);
      }

      const payload = {
        name: formData.name,
        mobile_number: formData.mobile_number,
        email: formData.email,
        cover_letter: formData.cover_letter,
        resume: base64Resume,
      };

      const response = await fetch(
        "https://api.app.mawalog.com/v1.2/job_apply",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result.success) {
        setMessage("Application submitted successfully!");
        setFormData({
          name: "",
          mobile_number: "",
          email: "",
          cover_letter: "",
          resume: null,
        });
        document.getElementById("resume").value = "";
      } else {
        setMessage("Submission failed.");
      }
    } catch (error) {
      setMessage("Network error or server issue.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
    
 
    <div className="bg-white text-gray-800">
      {/* Header */}
     
  <div className="bg-[#F9FCD0] py-14 text-center px-4">
      {/* Job Title and Company Info */}
      <div className="text-gray-700 text-sm font-medium mb-3">
        Lentera Technologies <span className="mx-2">|</span> Full Time
      </div>
      <h1 className="text-3xl md:text-5xl font-semibold text-gray-900 mb-6">
        Python developer
      </h1>

      {/* I'm Interested Button */}
      <button
  onClick={() => applyFormRef.current.scrollIntoView({ behavior: "smooth" })}
  className="bg-[#F4B731] hover:bg-[#e5a925] text-black font-semibold px-6 py-3 rounded-md text-sm md:text-base transition-all duration-200"
>
  I’M INTERESTED <span className="ml-1">→</span>
</button>


      {/* Divider Line */}
      {/* <hr className="my-10 w-full max-w-xl mx-auto border-t border-gray-300" /> */}

      {/* Share Icons */}
{/*       
      <div className="flex justify-center items-center gap-2 mt-8">
  <span className="text-sm font-medium text-gray-700">SHARE IT TO</span>
  <span className="text-sm font-medium text-gray-700">:</span>
  <div className="flex gap-4">
    <img src={gmailIcon} alt="Gmail" className="w-10 h-10 bg-white rounded-xl p-2 shadow-sm" />
    <img src={xIcon} alt="X" className="w-10 h-10 bg-white rounded-xl p-2 shadow-sm" />
    <img src={facebookIcon} alt="Facebook" className="w-10 h-10 bg-white rounded-xl p-2 shadow-sm" />
    <img src={instagramIcon} alt="Instagram" className="w-10 h-10 bg-white rounded-xl p-2 shadow-sm" />
    <img src={linkedinIcon} alt="LinkedIn" className="w-10 h-10 bg-white rounded-xl p-2 shadow-sm" />
  </div>
</div> */}

    </div>
      {/* Content */}
     
    <div className="bg-white px-6 md:px-16 py-12">
  <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">

    {/* LEFT SIDE: JOB DESCRIPTION */}
    
<div className="lg:col-span-2 space-y-12">
  {/* Job Summary Section */}
  <div>
    <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
      Job Summary
    </h2>

    <p className="text-[#212129] text-[18px] leading-8 mb-6">
      We are looking for a passionate and self-motivated Python Developer (Fresher) to join our development team in Chennai. This is an exciting opportunity for recent graduates or entry-level professionals to work in a collaborative environment, gain hands-on experience in back-end development, and contribute to real-world software projects.
    </p>

    <p className="text-[#212129] text-[18px] leading-8 mb-6">
      As a Python Developer, you will be responsible for developing and maintaining robust backend systems, applying object-oriented programming principles, and working closely with our cross-functional teams to design, develop, and deliver high-quality software solutions.
    </p>

    {/* Key Responsibilities */}
    <h3 className="text-[20px] font-semibold text-green-600 mb-1">
      Key Responsibilities
    </h3>
    <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

    <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
      <li>Write clean, efficient, and maintainable backend code using Python.</li>
      <li>Collaborate with front-end developers, designers, and product managers to develop seamless web applications.</li>
      <li>Apply Object-Oriented Programming (OOP) principles to ensure scalable and modular application design.</li>
      <li>Develop and integrate RESTful APIs and third-party services.</li>
      <li>Work with relational and/or NoSQL databases for data storage and retrieval.</li>
      <li>Participate in code reviews and follow best practices for coding standards and version control.</li>
      <li>Identify bottlenecks and bugs, and devise solutions to mitigate and address issues.</li>
      <li>Learn and adapt to new tools, technologies, and development methodologies as required.</li>
    </ul>
  </div>

  {/* Qualifications */}
  <div>
    <h3 className="text-[20px] font-semibold text-green-600 mb-1">
      Required Qualifications
    </h3>
    <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

    <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
      <li>Bachelor’s Degree in Computer Science, Information Technology, Engineering, or a related field.</li>
      <li>(B.Sc in Computer Science/IT, BCA, B.E/B.Tech, MCA preferred)</li>
      <li>Strong foundational knowledge of Python programming language.</li>
      <li>Understanding of Object-Oriented Programming (OOP) concepts.</li>
      <li>Basic knowledge of web development and how backend services function.</li>
      <li>Familiarity with databases (e.g., MySQL, PostgreSQL, SQLite, or MongoDB).</li>
      <li>Exposure to Python frameworks like Django or Flask is a plus.</li>
      <li>Hands-on academic projects, internships, or personal coding projects will be considered a strong advantage.</li>
      <li>Good understanding of Data Structures and Algorithms.</li>
    </ul>
  </div>

  {/* Skills and Competencies */}
  <div>
    <h3 className="text-[20px] font-semibold text-green-600 mb-1">
      Desired Skills
    </h3>
    <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

    <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
      <li>Familiarity with Python Modules and Packages.</li>
      <li>Knowledge of version control tools (e.g., Git/GitHub).</li>
      <li>Basic understanding of RESTful APIs and JSON.</li>
      <li>Strong analytical and debugging skills.</li>
      <li>Effective communication skills and the ability to work collaboratively in a team environment.</li>
      <li>Willingness to learn, grow, and take ownership of assigned tasks.</li>
    </ul>
  </div>
</div>


    {/* RIGHT SIDE: JOB INFORMATION */}
   <div className="bg-white p-6 rounded-2xl shadow-sm max-w-sm w-full">
      
       <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
      Job Information
    </h2>

      <div className="space-y-4">
        {/* Location */}
        <div className="flex items-center bg-[#F9FAFB] p-4 rounded-xl">
          <img src={locationIcon} alt="Location Icon" className="w-12 h-12 mr-4" />
          <div>
            <p className="text-[#9CA3AF] text-sm font-medium">Location</p>
            <p className="text-[#111827] text-base font-semi">Chennai</p>
          </div>
        </div>

        {/* Job Type */}
        <div className="flex items-center bg-[#F9FAFB] p-4 rounded-xl">
          <img src={fulltimeIcon} alt="Job Type Icon" className="w-12 h-12 mr-4" />
          <div>
            <p className="text-[#9CA3AF] text-sm font-medium">Job type</p>
            <p className="text-[#111827] text-base font-semi">Full time</p>
          </div>
        </div>

        {/* Experience */}
        <div className="flex items-center bg-[#F9FAFB] p-4 rounded-xl">
          <img src={experienceIcon} alt="Experience Icon" className="w-12 h-12 mr-4" />
          <div>
            <p className="text-[#9CA3AF] text-sm font-medium">Experience</p>
            <p className="text-[#111827] text-base font-semi">Fresher</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>


      {/* Apply Form */}
      
    </div>
    
    
          <div ref={applyFormRef} className="bg-[#F6F9FC] px-4 md:px-16 py-12">
           <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-semibold text-gray-900 mb-4">
          Apply for this role
        </h2>
        <p className="text-gray-600 mb-8">
          Please fill in your personal details below to apply for this role.
        </p>

        <form onSubmit={handleSubmit} className="space-y-6 bg-white p-6 rounded-xl shadow-md">
          {/* Upload Resume */}
          <div>
            <label className="block text-[17px] font-medium text-gray-800 mb-2">
              Upload your resume/cv
            </label>
            <div className="border border-dashed border-gray-300 rounded-md p-6 text-center bg-[#FCFCFC]">
              <p className="font-semibold text-gray-700 mb-1">
                Choose a file or drag & drop it here
              </p>
              <p className="text-sm text-gray-400 mb-4">
                Only .doc, .docx, .pdf, .odt, .rtf
              </p>
              <label htmlFor="resume" className="inline-flex items-center gap-2 px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-full cursor-pointer">
                <img src={uploadIcon} alt="Upload" className="w-5 h-5" />
                Upload
              </label>
              <input
                id="resume"
                name="resume"
                type="file"
                accept=".doc,.docx,.pdf,.odt,.rtf"
                className="hidden"
                onChange={handlleChange}
                required
                
              />
               {formData.resume && (
                <p className="text-sm text-green-600 mt-2">
                  {formData.resume.name}
                </p>
              )}
            </div>
          </div>

          {/* Name */}
          <div>
            <label className="block text-[15px] font-medium text-gray-700 mb-1">Name</label>
            <input
              type="text"
              name="name"
              placeholder="Your name"
              value={formData.name}
              onChange={handlleChange}
              required
              className="w-full border border-gray-300 rounded-md p-3 focus:border-green-600 focus:outline-none transition"
            />
          </div>

          {/* Phone Number */}
          <div>
            <label className="block text-[15px] font-medium text-gray-700 mb-1">Phone number</label>
            <input
              type="tel"
              name="mobile_number"
              placeholder="Your phone number"
              value={formData.mobile_number}
              onChange={handlleChange}
              required
              className="w-full border border-gray-300 rounded-md p-3 focus:border-green-600 focus:outline-none transition"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-[15px] font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              name="email"
              placeholder="Your email address"
              value={formData.email}
              onChange={handlleChange}
              required
              className="w-full border border-gray-300 rounded-md p-3 focus:border-green-600 focus:outline-none transition"
            />
          </div>

          {/* Cover Letter */}
          <div>
            <label className="block text-[15px] font-medium text-gray-700 mb-1">Cover letter</label>
            <textarea
              name="cover_letter"
              rows="4"
              placeholder="Write your message here..."  
              value={formData.cover_letter}
              onChange={handlleChange}
              required
              className="w-full border border-gray-300 rounded-md p-3 focus:border-green-600 focus:outline-none transition"
            />
          </div>

          {/* Consent Checkbox */}
          <div className="flex items-start">
            <input
              id="consent"
              type="checkbox"
              required
              className="mt-1 mr-2"
            />
            <label htmlFor="consent" className="text-sm text-gray-600">
              By using this form you agree with the storage and handling of your data by this website. *
            </label>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded-md transition"
          >
            {loading ? "Submitting..." : "SUBMIT"}
          </button>

          {message && (
            <p className="text-center text-sm mt-4 text-gray-700">
              {message}
            </p>
          )}
        </form>
      </div>
    </div>
  
    </>
  );
};

export default JobDetails;
